import * as React from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import Home from "../../components/home/home";
import AuthService from '../../services/authService';
import UserContainer from '../users/userContainer';
import ProductsContainer from '../products/productsContainer';
import AccessoriesContainer from '../accessories/accessoriesContainer';
import OffersContainer from '../offers/offersContainer';
import { connect } from 'react-redux';
import LoginComponent from '../login/loginComponent';
import Translate from '../../common/functions/translate';
import UserProfile from '../profile/userProfile';
import RegionsContainer from '../configuration/regions/regionsContainer';
import CategoriesContainer from '../configuration/categories/categoriesContainer';
import LogFilesContainer from '../system/logFiles/logFilesContainer';

const NoMatch = () => (
    <div>
        <h3>
            URL address <code>{window.location.pathname}</code> not match.
    </h3>
    </div>
);

const NotAuthorizedComponent = () => (
    <div className="app-content">
        <h3>{Translate('You are not Authenticated to view this resource')}</h3>
    </div>)


interface Iprops {
    history: any,
    isUserLogged: boolean;
    lang: string;
}

interface IState {
}

class Navigation extends React.Component<Iprops, IState> {
    authService = new AuthService();

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <>
                <Switch>
                    <Route exact path="/" component={this.authService.isAuthenticated() ? Home : LoginComponent} />
                    <Route exact path="/login" component={this.authService.isAuthenticated() ? Home : LoginComponent} />
                    <Route path="/users" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() ? UserContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/products" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() || this.authService.checkIsProductManager() ? ProductsContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/accessories" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() || this.authService.checkIsProductManager() ? AccessoriesContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/offers" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() || this.authService.checkIsRegionalManager() || this.authService.checkIsTrader() ? OffersContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/userprofile" component={this.authService.isAuthenticated() ? UserProfile : LoginComponent} />
                    <Route path="/configuration/regions" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() ? RegionsContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/configuration/categories" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() ? CategoriesContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route path="/system/logs" component={this.authService.isAuthenticated() ?
                        this.authService.checkIsAdmin() ? LogFilesContainer : NotAuthorizedComponent
                        : LoginComponent} />
                    <Route component={NoMatch} />
                </Switch>
            </>
        )
    }
}

const mapsStateToProps = state => {
    return {
        isUserLogged: state.common.isUserLogged,
        lang: state.common.lang
    };
}


export default withRouter(connect(mapsStateToProps)(Navigation));